import { cn } from '@opendoor/atoms/utils';
import type { useTouring } from 'components/self-tour/hooks/useTouring';

import { PdpRaisedButton } from './PdpRaisedButton';

export type TourAction = NonNullable<ReturnType<typeof useTouring>>['primaryAction'];

export const TourActionButton = ({
  action,
  label = action.text,
  variant = action.variant,
  className,
}: {
  action: TourAction;
  label?: string;
  variant?: TourAction['variant'];
  className?: string;
}) => (
  <PdpRaisedButton
    analyticsName={action.analyticsName}
    data-analytics-name={action.analyticsName}
    aria-label={label}
    variant={variant}
    size="md"
    onClick={action.onClick}
    disabled={action.disabled}
    href={action.disabled ? undefined : action.href}
    target={action.target}
    rel="noopener"
    className={cn(
      'w-full min-w-0 whitespace-nowrap px-2 text-label-sm transition-none not-disabled:active:scale-100',
      className,
    )}
  >
    {label}
  </PdpRaisedButton>
);
